import NP from "./NP";

interface EventHandler {
	Callback: Function,
	Context: Object,
	Args: any,
	Arguments: any
}

export default class Delegate {

	_handlers: Array<EventHandler>;

	public constructor(func?: any, context?: any, args?: any, argums?: any)
	{
		if (func)
			this.add(func, context, args, argums);
	}

	_contains(func: any, context: any)
	{
		if (!func)
			throw new Error("Event._contains: func is null");
		if (!this._handlers || !this._handlers.length) return false;
		if (!context)
			context = null;
		for (let h of this._handlers)
		{
			if (h.Callback == func && h.Context === context)
				return true;
		}
		return false;
	}

	public add(func: any, context?: any, args?: any, argums?: any)
	{
		if (!func)
			return null;

		let on = this._handlers;
		if (!on)
			on = this._handlers = [];
		if (!context)
			context = null;
		if (func instanceof Delegate)
		{
			if (func._handlers)
			{
				this._handlers = on.concat(func._handlers);
				return on.length;
			}
			else
				return false;
		}
		else
		{
			let id = on.length;
			on.push({
				Callback: func,
				Context: context,
				Args: args,
				Arguments: argums
			});
			return id;
		}
	}

	static isFunction(v: object)
	{
		return Object.prototype.toString.apply(v) === '[object Function]';
	}

	public addOne(func: any, context: object, args?: object, argums?: object)
	{
		if (!this._contains(func, context))
			this.add(func, context, args, argums);
	}

	insert(index: number, func: any, context: object, args?: object)
	{
		if (!func)
			throw new Error("Event.insert: func is null");
		this._handlers = this._handlers || [];
		if (func instanceof Delegate)
		{
			if (func._handlers)
			{
				for (let h of func._handlers)
					NP.insertToArray(this._handlers, h, index++);
				return this._handlers.length;
			}
			else
				return false;
		}
		else
		{
			let id = this._handlers.length;
			if (!context)
				context = null;
			NP.insertToArray(this._handlers, {
				Callback: func,
				Context: context,
				Args: args
			}, index);
			return id;
		}
	}

	remove(func: any, context?: object)
	{
		if (!this._handlers) return;
		context = context ? context : null;
		let type = (typeof (func)).toLowerCase();
		if (type == 'number')
		{
			if (this._handlers.length > func)
				this._handlers.splice(func, 1);
		}
		else
		{
			if (type == 'function')
			{
				for (let i = this._handlers.length - 1; i >= 0; i--)
				{
					if (!this._handlers[i]) continue;
					if (this._handlers[i].Callback == func)
					{
						if (this._handlers[i].Context === context)
						{
							this._handlers.splice(i, 1);
							return;
						}
					}
				}
			}
			else if (func instanceof Delegate)
			{
				if (func._handlers && func._handlers.length > 0)
				{
					for (let i = 0; i < func._handlers.length; i++)
						this.remove(func._handlers[i].Callback, func._handlers[i].Context);
				}
			}
			else
				throw new Error("Event.remove");
		}
	}

	clear(context: object = null)
	{
		if (this._handlers)
		{
			for (let i = this._handlers.length - 1; i >= 0; i--)
			{
				if (this._handlers[i] && context === this._handlers[i].Context)
					this._handlers.splice(i, 1);
			}
		}
	}

	clearAll()
	{
		this._handlers = [];
	}

	fire(sender: any, args?: any, timeout?: number)
	{
		let items = this._handlers;
		if (!items || !items.length)
			return;

		args = args || {};
		if (timeout != undefined)
		{
			setTimeout(() => this.fire(sender, args), timeout);
			return;
		}

		let cloneHandlers = (items.length == 1 ? items : [].concat(items)),
			 res;
		for (let handler of  cloneHandlers)
		{
			if (handler && handler.Callback)
			{
				if (handler.Context)
				{
					if (handler.Args)
						args.Args = handler.Args;
					if (handler.Context.isLive && !handler.Context.isLive())
						this.remove(handler.Callback, handler.Context);
					else if (handler.Arguments)
						res = handler.Callback.apply(handler.Context, handler.Arguments);
					else
						res = handler.Callback.call(handler.Context, sender, args);
				}
				else
					res = handler.Callback.call(sender, sender, args);
				if (args && args.Break)
					break;
			}
		}
		return res;
	}

	clone()
	{
		return new Delegate(this);
	}

	destroy()
	{
		delete this._handlers;
	}

	getCount()
	{
		return this._handlers ? this._handlers.length : 0;
	}

	getArgs(index: number = 0)
	{
		return this._handlers[index].Args;
	}

	static fire(callback: any, sender?: object, args?: any, timeout?: number)
	{
		if (callback)
		{
			if (callback instanceof Delegate)
				callback.fire(sender, args, timeout);
			else if (Delegate.isFunction(callback))
			{
				if (timeout != null)
				{
					setTimeout(function ()
					{
						callback.call(window, sender, args);
					}, timeout);
				}
				else
					callback.call(window, sender, args);
			}
		}
	}

	static fires(arr: Array<Event> | Function[], sender: object, args: any, timeout?: number)
	{
		if (arr)
		{
			for (let c of arr)
				Delegate.fire(c, sender, args, timeout);
		}
	}

}